import React from "react";
import "./AllComment.css";

const FALLBACK_AVATAR = "https://storage.googleapis.com/vidyakasam-user/default/vidyakasam_logo.jpg";

const AllComment = ({ comments = [], onLike, onReply, isLiking = false }) => (
  <div className="commnts-list">
    {comments.map((comment) => <article className="commnt-card" key={comment.comment_id}>
      <div className="commnt-user">
        <div className="commentss-avatar"><img src={comment.image_url || FALLBACK_AVATAR} alt="" /></div>
        <div className="commnt-user-info"><h4>{comment.username || "User"}</h4><span>{comment.timeAgo || comment.created_at || ""}</span></div>
      </div>
      <p className="commnt-text">{comment.text}</p>
      <div className="commnt-actions">
        <button type="button" onClick={() => onLike(comment)} disabled={isLiking}><i className={`bi ${Number(comment.like_status) === 1 ? "bi-heart-fill" : "bi-heart"}`} /><span>Like</span><strong>{comment.total_likes || 0}</strong></button>
        <span className="action-divider" />
        <button type="button" className="replyy" onClick={() => onReply?.(comment)}>Reply ({comment.child_count || 0})</button>
      </div>
    </article>)}
  </div>
);

export default AllComment;
